
import { defineComponent } from 'vue';
import commonApi from '@/api/common';

const columns = [
  {
    title: '投标项目',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '周期',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '金额',
    dataIndex: 'price',
    key: 'price',
  },
];
const list = [
  {
    key: '1',
    name: '电商独立版',
    time: '365天',
    price: '￥5,800.00',
  },
];
export default defineComponent({
  name: 'Detail',
  data() {
    return {
      visible: false,
      columns,
      list,
      info: {},
    };
  },
  components: {
  },
  methods: {
    showVisible(item: TObject) {
      console.log(item);
      this.getDetail(item);
    },
    getDetail(item: TObject) {
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.getSaasUpgradePayDetail({
        siteId: item.siteId,
        rechargeNo: item.rechargeNo,
      }).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.info = data;
          this.list[0] = {
            key: data.rechargeNo,
            name: data.versionName,
            time: `${data.cycle}天`,
            price: data.amount,
          };
          this.visible = true;
        } else {
          console.log(message);
        }
      });
    },
    close() {
      this.visible = false;
    },
    payNow() {
      const parent = this.$parent as unknown as {[x: string]: Function};
      parent.handleToPay(this.info);
      this.close();
    },
  },
});
